<template>
	<v-avatar :class="['avatar', dynamicAvatarClass]" :size="size" :color="color">
		<img v-if="avatar" referrerpolicy="no-referrer" :src="avatar" alt="avatar" loading="lazy" />
		<Icon v-else type="profile" color="white" :size="size" />
	</v-avatar>
</template>

<script>
export default {
	name: 'Avatar',
	props: {
		avatar: {
			type: String,
			default: '',
		},
		size: {
			type: Number,
			default: 50,
		},
		color: {
			type: String,
			default: '#e0e0e0',
		},
		borderRadius: {
			type: String,
			default: 'circle',
		},
	},
	computed: {
		dynamicAvatarClass() {
			return {
				'rounded-lg': this.$props.borderRadius === 'square',
			}
		},
	},
}
</script>

<style lang="scss">
.avatar {
	img {
		object-fit: cover;
	}

	&__default-icon {
		border-radius: 25px;
	}
}
</style>
